/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAuth } from 'common/contexts/auth';
import Page404 from 'common/pages/Page404';

import { loader } from 'common/components/PageLoader/PageLoader';

const getUserRoutes = (routes, user) => routes.map((route, key) => {
  let { component } = route;
  const {
    path, roles = null, exact = true,
  } = route;

  if (roles) {
    if (user && user.role) {
      if (!roles.includes(user.role.name)) {
        component = Page404;
      }
    } else {
      component = () => (<Redirect to="/login" />);
    }
  }

  return <Route key={key} path={path} exact={exact} component={component} />;
});

const Routes = ({ routes }) => {
  const { user, refreshUser, isUserRefreshing } = useAuth();

  useEffect(() => {
    refreshUser();
  }, []);

  const userRoutes = useMemo(() => getUserRoutes(routes, user), [routes, user]);

  return isUserRefreshing ? loader() : userRoutes;
};

Routes.propTypes = {
  routes: PropTypes.array.isRequired,
};

export default Routes;
